import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/app/global-error.tsx");
